import React from 'react'
import { Card, Icon, Flag } from 'semantic-ui-react'
import ListShorthand from './ListShorthand.js'
import myphoto from '../assets/images/my-photo.png'

const Myprofile = (props) => (
  <div className="profile-content">
    <Card>
      <Card.Content>
        <Card.Header>
          <img className="my-photo" src={myphoto} />
        </Card.Header>
        <Card.Header>{props.profile.name}</Card.Header>
        <Card.Description>{props.profile.city} <Flag name='myanmar' /></Card.Description>
        <Card.Description className='my-job-title'>
          {props.profile.jobtitle}
        </Card.Description>
        <Card.Description className={props.lang+' my-description'}>
          {props.profile.my_description}
        </Card.Description>
        <Card.Description>
          <ListShorthand />
        </Card.Description>
      </Card.Content>
      <Card.Content extra>
        <a rel="noopener noreferrer" target="_blank" href="https://www.linkedin.com/in/adam-ouyang/">
          <Icon name='linkedin square' />
          Linkedin
        </a>
      </Card.Content>
    </Card>
    
    <div className="version_info">
      {props.version_info} <a rel="noopener noreferrer" target="_blank" href="https://reactjs.org">React</a>, <a rel="noopener noreferrer" target="_blank" href="http://redux.js.org">Redux</a>
    </div>
  </div>

)

export default Myprofile


// WEBPACK FOOTER //
// ./src/components/Myprofile.js